import { Directive, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { isElectronApp } from 'motion-master-client';

@Directive({ selector: '[appIsElectron]' })
export class isElectronDirective implements OnInit {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  private isElectron = false;

  async ngOnInit() {
    this.isElectron = await isElectronApp();
    if (this.isElectron) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
